export enum ButtonFloatingSize {
  SM = 'sm',
  RG = 'rg'
}
